import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { DASHBOARD_DAILY_CONTEST } from '../../../sagas/type';
import '../../../scss/pages/Home/DailyAnalytics/dailyAnalytics.scss'
import { getLocalStoreString } from '../../../utils/Helper';

const dailyAnalytics = () => {

    const dispatch = useDispatch()
    const { dashboardDailyContest, } = useSelector(mapStateToProps);
    const [dailyDate, setDailyDate] = useState('')

    const boxData = [
        { name: 'Target', value: 2000, },
        { name: 'Achieved', value: 2000, },
        { name: 'Target Achieved %', value: '100%', },
        { name: 'Quality', value: '100 %', },
        { name: 'Leaves', value: 1, }
    ]

    useEffect(() => {
        dailyAnalytics();
    }, []);

    useEffect(() => {
        if (dashboardDailyContest && dashboardDailyContest.date) {
            dailyDateConvert();
        }
    }, [dashboardDailyContest]);


    const dailyAnalytics = () => {
        const contestId = getLocalStoreString("ContestId");
        const empCode = getLocalStoreString("EmployeeCode");
        dispatch({
            type: DASHBOARD_DAILY_CONTEST,
            payload: { contestId, EmployeeCode: empCode }
        })
    }

    const dailyDateConvert = () => {
        var inputDate = dashboardDailyContest?.date
        const dateParts = inputDate?.split('-');
        const dateObj = new Date(`20${dateParts[0]}`, parseInt(dateParts[1]) - 1, dateParts[2]);
        const outputDate = dateObj.toLocaleString("en-US", { month: 'long', day: "2-digit" });
        setDailyDate(outputDate);
    }

    return (
        <Box >
            <Typography padding='24px 24px 24px 0px' fontWeight='500' fontStyle='normal' fontSize='24px' lineHeight='44px' color='#FFFFFF'>Daily Summary ({dailyDate})</Typography>
            <div className='dailyCardContainer'>
                {dashboardDailyContest && dashboardDailyContest.parameters && dashboardDailyContest.parameters.length > 0 && dashboardDailyContest.parameters.map((data) => {
                    return (
                        <div className='dailyCardContainer_dailyAnalyticsBox'>
                            <Typography color='#BFC7D7' padding='0.5rem'>{data?.name}</Typography>
                            <Typography fontStyle='normal' padding='0rem 0.5rem 0.5rem 0.5rem' fontWeight='700' fontSize='1.4rem' lineHeight='2rem' textAlign='center' color='#FFFFFF'>{data?.value}</Typography>
                        </div>
                    )
                })
                }
            </div>
        </Box >
    )
}

const mapStateToProps = (state) => {
    return {
        dashboardDailyContest: state.dashboardConfig.dashboardDailyContestData,
    }
}


export default dailyAnalytics;